import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { IXeroSignUpFormProps } from '../types';
import { xeroSignupValidationSchema } from '../utils/validation';

export const useXeroSignUpForm = () => {
  const methods = useForm<IXeroSignUpFormProps>({
    defaultValues: {
      isTermsAccepted: false,
      email: '',
      organization_name: '',
      password: '',
      phone_number: '',
      user_name: '',
    },
    resolver: zodResolver(xeroSignupValidationSchema),
  });

  return { methods };
};
